import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { ListItemBox } from "lib/@components/ListItemBox"
import { Button, Link, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { navigate } from "lib/routes/navigate"

export function Schedules({ list, schedules }) {
    const [open, setOpen] = useBoundValue("schedulesOpen", false)
    const { currentTitles } = useBoundContext()
    if (schedules.length < 2) {
        currentTitles.schedule = list[0].schedule
        return (
            <ListItemBox spacing={1}>
                <Typography variant="body2">
                    <Link data-cy="schedule-link" onClick={go}>
                        {list[0].schedule.title} #{list[0].schedule.code}
                    </Link>
                </Typography>
            </ListItemBox>
        )
    }
    currentTitles.schedule = null
    return (
        <Button
            data-cy="schedules-section"
            size="small"
            sx={{ mt: -0.5 }}
            onClick={() => setOpen(!open)}
            endIcon={<Iconify icon={open ? "mdi:keyboard-arrow-down" : "mdi:keyboard-arrow-right"} />}
        >
            Schedules ({schedules.length})
        </Button>
    )

    function go() {
        navigate(`/app/schedules/${list[0].taskObject.scheduleId}`)
    }
}
